import {
  DEFAULT_CONTENT_MEDIA_POSITION,
  DEFAULT_HERO_MEDIA_KIND,
  isSingletonBlockType,
} from '@provision/landing-page-utils';
import {
  type LandingPageBlockType,
  type LandingPageBlockValues,
} from 'src/pages/Settings/memberships/components/landing-page-tab/types';

export function emptyBlockValues(): Omit<LandingPageBlockValues, 'id' | 'type'> {
  return {
    heroHeadline: '',
    heroSubtext: '',
    heroMediaKind: DEFAULT_HERO_MEDIA_KIND,
    heroVideoUrl: '',
    heroVideoTitle: '',
    heroVideoCaption: '',
    heroImageUrl: '',
    contentKicker: '',
    contentTitle: '',
    contentBody: '',
    contentImageUrl: '',
    contentMediaPosition: DEFAULT_CONTENT_MEDIA_POSITION,
    ctaHeadline: '',
    ctaSubtext: '',
    ctaButtonLabel: '',
  };
}

// Ids are in-page anchors and key both the sortable list and the renderer, so they must be unique.
export function nextBlockId(
  type: LandingPageBlockType,
  existing: readonly { id: string }[],
): string {
  const taken = new Set(existing.map((block) => block.id));

  if (isSingletonBlockType(type)) {
    return type;
  }

  for (let suffix = 1; ; suffix += 1) {
    const candidate = `${type}-${suffix}`;
    if (!taken.has(candidate)) {
      return candidate;
    }
  }
}

const STARTER_COPY: Partial<Record<LandingPageBlockType, Partial<LandingPageBlockValues>>> = {
  hero: { heroHeadline: 'Technology that *just works*' },
  content: { contentKicker: 'New section', contentTitle: 'Untitled block' },
  closingCta: { ctaHeadline: 'Ready to get started?', ctaButtonLabel: 'Get started' },
};

export function createLandingPageBlock(
  type: LandingPageBlockType,
  existing: readonly { id: string }[],
): LandingPageBlockValues {
  return {
    id: nextBlockId(type, existing),
    type,
    ...emptyBlockValues(),
    ...STARTER_COPY[type],
  };
}
